import { render } from "./GradientLegend.vue?vue&type=template&id=28491268&ts=true"
import script from "./GradientLegend.vue?vue&type=script&lang=ts"
export * from "./GradientLegend.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__